// Contact.js
import React from 'react';
// No need to import contact_bg.jpg here if it's set as a CSS background from src/assets

function Contact({ language, content }) { // 'content' prop might have translations if you set them up
  // Using contact details from PDF source [7] as specified
  const reachOutText = language === 'pt' ? "Entre em contato!" : "reach out!"; // Example translation
  const email = "benbhicks47@gmail.com";
  const phone = "+351 910 393 130";

  return (
    <section id="contact" className="contact-section">
      <div className="contact-text-box">
        <h2>{reachOutText}</h2> {/* Text from PDF source [7] */}
        <p className="contact-detail">
          <a href={`mailto:${email}`}>{email}</a>
        </p>
        <p className="contact-detail">
          <a href={`tel:${phone.replace(/\s+/g, '')}`}>{phone}</a>
        </p>
      </div>
    </section>
  );
}

export default Contact;